// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-criteria-detail-list {
  display: flex;
  flex-direction: column;
}

.fund-criteria-detail-list-empty {
  color: var(--text-label);
  padding: 16px 0;
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/Criteria/FundCriteriaDetailList/FundCriteriaDetailList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".fund-criteria-detail-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.fund-criteria-detail-list-empty {\n  color: var(--text-label);\n  padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
